module.exports = __webpack_public_path__ + "static/media/2011_metro_ministries.0ba2da2f.jpg";